import React from 'react'
import { useSelector } from 'react-redux';
import RecentCardListContainer from '../RecentCardListContainer';

function RecentList({ title }) {
    const { user } = useSelector((state) => state.user);
    return (
        <RecentCardListContainer user={user} matches={user.myRecentVisitors} title={title} />
    )
}

export default RecentList